import React from "react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { COMPANY } from "../lib/constants";

export default function Privacy() {
  return (
    <div>
      <Seo title="Privacy Policy" description="How Melopa Invents Pvt Ltd handles your personal information and requirements data." path="/privacy-policy" />
      <PageHero kicker="Legal" title="Privacy Policy" description="This page explains how Melopa Invents Pvt Ltd collects, uses, and safeguards your information." />
      <section className="section">
        <div className="container-x max-w-3xl text-[15px] leading-relaxed text-[var(--melopa-text)] space-y-5">
          <p>At {COMPANY.name} (“we”, “us”, “our”), we respect your privacy and are committed to protecting any personal information you share with us through this website.</p>
          <h2 className="text-xl font-bold text-navy mt-6">Information we collect</h2>
          <ul className="list-tick">
            <li>Contact details (name, organization, designation, phone, WhatsApp, email).</li>
            <li>Requirement details, quantity, location, deadlines and uploaded documents.</li>
            <li>Document access requests (name, organisation, phone, email, purpose).</li>
            <li>Basic technical metadata (timestamps).</li>
          </ul>
          <h2 className="text-xl font-bold text-navy mt-6">How we use it</h2>
          <ul className="list-tick">
            <li>To respond to your requirement, tender enquiry, or vendor request.</li>
            <li>To process documentation, quotations, and follow-ups.</li>
            <li>To improve our services and internal record-keeping.</li>
          </ul>
          <h2 className="text-xl font-bold text-navy mt-6">Sharing & retention</h2>
          <p>We do not sell your data. Information is shared only with our internal team, sourcing partners, and qualified technical partners strictly to fulfil the requirement you have submitted. We retain records for as long as needed to provide our services and meet legal/accounting obligations.</p>
          <h2 className="text-xl font-bold text-navy mt-6">Your rights</h2>
          <p>You may request access, correction, or deletion of your data by emailing <a className="text-navy underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</p>
          <h2 className="text-xl font-bold text-navy mt-6">Security</h2>
          <p>Submissions and uploaded documents are stored on our managed servers with reasonable security controls. No method of online transmission or storage is 100% secure.</p>
          <h2 className="text-xl font-bold text-navy mt-6">Contact</h2>
          <p>For any privacy-related question, write to <a className="text-navy underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> or call {COMPANY.phone}.</p>
          <p className="text-xs text-[var(--melopa-muted)]">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}</p>
        </div>
      </section>
    </div>
  );
}
